import React, { useState } from "react";
import Dropdown from "rc-dropdown";
import DefaultButton from "../../../styles/materialButtonStyle";
import { DelayInput } from "react-delay-input/lib/Component";
import MappedServicesFilter from "../../serviceReletionships/mappedServices/MappedServicesFilter";
import TransactionStatusSelect from "../../transactions/TransactionStatusSelect";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledSelectGroup,
  StyledShowFilterBtn
} from "../../filter/styledFiter";

const TransferFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("transferPage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "id": "",
    "note": "",
    "currency.asset": null,
    "service.name": null,
    "status": null,
    "receiver.email": "",
    "receiver.nickname": "",
    "sender.email": "",
    "sender.nickname": "",
    "itemsPerPage": filterData["itemsPerPage"] ?? null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="id">Id</label>
              <DelayInput
                id="id"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "id": event.target.value, page: 1 })}
                name="id"
                value={filterData["id"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="note">
                {t("filter.note")}
              </label>
              <DelayInput
                id="note"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "note": event.target.value, page: 1 })}
                name="note"
                value={filterData["note"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="email">
                {t("filter.sender")}
              </label>
              <DelayInput
                id="email"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "sender.email": event.target.value, page: 1 })}
                name="email"
                value={filterData["sender.email"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="email">
                {t("filter.receiver")}
              </label>
              <DelayInput
                id="email"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "receiver.email": event.target.value, page: 1 })}
                name="email"
                value={filterData["receiver.email"]}
                type="text"
              />
            </StyledFilterGroup>

            <StyledFilterGroup>
              <label htmlFor="nickname">
                {t("filter.snickname")}
              </label>
              <DelayInput
                id="snickname"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "sender.nickname": event.target.value, page: 1 })}
                name="snickname"
                value={filterData["sender.nickname"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="nickname">
                {t("filter.rnickname")}
              </label>
              <DelayInput
                id="rnickname"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "receiver.nickname": event.target.value, page: 1 })}
                name="rnickname"
                value={filterData["receiver.nickname"]}
                type="text"
              />
            </StyledFilterGroup>
            <MappedServicesFilter
              checkedService={filterData["service.name"]}
              setCheckedService={data => handleChangeFilterData(data, "service.name")}

              checkedCurrency={filterData["currency.asset"]}
              setCheckedCurrency={data => handleChangeFilterData(data, "currency.asset")}

              withPaymentSystem={false}
            />
            <StyledSelectGroup>
              <TransactionStatusSelect
                checkedStatus={filterData["status"]}
                setCheckedStatus={(data) => setFilterData({ ...filterData, "status": data, page: 1 })}
                defaultOption={true}
              />
            </StyledSelectGroup>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <>
      <StyledFilterWrapper id="filter">
        <Dropdown
          getPopupContainer={() => document.getElementById("filter")}
          overlay={FilterList}
          trigger={["click"]}
          placement="bottomLeft"
          onVisibleChange={onVisibleChange}
          visible={visible}
          closeOnSelect={false}
        >
          <StyledShowFilterBtn>
            <DefaultButton
              color="success"
            >
              {t("filter.filterBtn")}
            </DefaultButton>
          </StyledShowFilterBtn>
        </Dropdown>
      </StyledFilterWrapper>
    </>
  );
};

export default TransferFilter;